import React from "react";
import Link from 'next/link';
import Card from "../ui/Card";
import { useSearchParams } from 'next/navigation';
import { getRarityColors } from "@/utils/helpers/helperFunctions";
import { getStoreDisplayPrice, formatStorePrice } from "@/utils/helpers/storeProductPrice";

const ProductCard = ({ product }) => {
  const searchParams = useSearchParams();
  const referrer = searchParams.get('referrer');

  // Destructure the NFT properties based on actual data structure
  const {
    pid,
    video_url,
    name,
    category,
    rarity,
    remaining_supply,
    default_currency,
    image_website,
    is_limited,
    is_coming_soon,
    type,
  } = product;

  const currency = default_currency?.symbol;
  const displayPrice = getStoreDisplayPrice(product);
  const priceLabel = formatStorePrice(displayPrice);

  const { textClass: rarityTextClass, borderClass: rarityBorderClass } = getRarityColors(rarity);

  return (
    (is_limited && remaining_supply === 0) ? (
      <div className="card bg-[#141414] nftItemCard">
          <Card noborder bodyClass="p-0">
            {rarity && (
                <div className={`absolute top-2 right-2 inline-flex items-center justify-center h-6 px-2 bg-[#1A1D24] rounded-md uppercase border ${rarityBorderClass}`} style={{ zIndex: 10 }}>
                    <span className={`text-[10px] leading-none font-bold ${rarityTextClass}`}>{rarity}</span>
                </div>
            )}

            <div className="nft-box">
                {video_url ? (
                  <div className="video-container">
                      <video
                          src={video_url}
                          autoPlay
                          loop
                          muted
                          playsInline
                      />
                  </div>
                ) : image_website?.medium ? (
                    <img
                        src={image_website.medium}
                        alt={name}
                        className="w-full h-full object-contain bg-[#000000]"
                    />
                ) : (
                    <div className="w-full h-full bg-[#141414] flex items-center justify-center">
                        <span className="text-gray-400">No Media Available</span>
                    </div>
                )}
            </div>

            <div className="p-2">
                <div className="flex items-center p-2 bg-[#070707] rounded-lg">
                    <p className="text-base font-medium text-white bg-[#141414] rounded-lg px-2 py-1">{name}</p>
                </div>
                <div className="bg-[#070707] p-2 mt-2 rounded-lg flex justify-between items-center">
                  <div className="min-h-[3.5rem]">
                      <p className="text-lg font-bold text-white ml-1">
                        {priceLabel ? `${priceLabel} ${currency ?? ""}`.trim() : ""}
                      </p>
                      <p className="bg-[#141414] text-red-500 text-xs font-normal px-2 py-1 rounded-lg flex items-center gap-1">
                          <img 
                              src="/assets/images/store/sold-out.png"
                              alt="Sold Out" 
                              style={{
                                  width: '15px',
                                  height: '15px',
                                  objectFit: 'contain',
                                  opacity: 0.8,
                              }} 
                          />
                          <span>SOLD OUT</span>
                      </p>
                    </div>
                </div>
            </div>
          </Card>
        </div>
    ) : (is_coming_soon ? (
        <div className="card bg-[#141414] nftItemCard">
        <Card noborder bodyClass="p-0">
            {rarity && (
                <div className={`absolute top-2 right-2 inline-flex items-center justify-center h-6 px-2 bg-[#1A1D24] rounded-md uppercase border ${rarityBorderClass}`} style={{ zIndex: 10 }}>
                    <span className={`text-[10px] leading-none font-bold ${rarityTextClass}`}>{rarity}</span>
                </div>
            )}

          <div className="nft-box">
              {video_url ? (
                <div className="video-container">
                    <video
                        src={video_url}
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                </div>
              ) : (image_website?.medium) ? (
                  <img
                      src={image_website?.medium}
                      alt={name}
                      className="w-full h-full object-contain bg-[#000000]"
                  />
              ) : (
                  <div className="w-full h-full bg-[#141414] flex items-center justify-center">
                      <span className="text-gray-400">No Media Available</span>
                  </div>
              )}
          </div>
          <div className="p-2">
              <div className="flex items-center p-2 bg-[#070707] rounded-lg">
                  <p className="text-base font-medium text-white bg-[#141414] rounded-lg px-2 py-1">{name}</p>
              </div>
              <div className="bg-[#070707] p-2 mt-2 rounded-lg flex justify-between items-center">
                  <div className="min-h-[3.5rem]">
                      <p className="text-lg font-bold text-white ml-1">
                        {priceLabel ? `${priceLabel} ${currency ?? ""}`.trim() : ""}
                      </p>
                      <p className="bg-[#141414] text-red-500 text-xs font-normal px-2 py-1 rounded-lg flex items-center gap-1">
                          <img 
                              src="/assets/images/store/coming-soon.png"
                              alt="Coming Soon" 
                              style={{
                                  width: '15px',
                                  height: '15px',
                                  objectFit: 'contain',
                                  opacity: 0.8,
                              }} 
                          />
                          <span>COMING SOON</span>
                      </p>
                  </div>
              </div>
          </div>
        </Card>
    </div>
    ) : (
        <Link 
            href={`${
                category === 'gem' ? '/payments_gem' : 
                category === 'premium' ? '/payments_premium' : 
                category === 'hosting' ? '/payments_hosting' :
                category === 'nft' && type === 'licence' ? '/payments_nodes' :
                category === 'nft' ? '/payments' : '/payments'
            }?pid=${pid}${referrer ? `&referrer=${referrer}` : ''}`}
            passHref
        >
            <Card
                noborder
                bodyClass="p-0"
                className="bg-[#141414] nftItemCard"
            >
                {rarity && (
                    <div className={`absolute top-2 right-2 inline-flex items-center justify-center h-6 px-2 bg-[#1A1D24] rounded-md uppercase border ${rarityBorderClass}`} style={{ zIndex: 10 }}>
                        <span className={`text-[10px] leading-none font-bold ${rarityTextClass}`}>{rarity}</span>
                    </div>
                )}
                <div className="nft-box">
                    {video_url ? (
                        <div className="video-container">
                            <video
                                src={video_url}
                                autoPlay
                                loop
                                muted
                                playsInline
                            />
                        </div>
                    ) : (image_website?.medium) ? (
                        <img
                            src={image_website?.medium}
                            alt={name}
                            className="w-full h-full object-contain bg-[#000000]"
                        />
                    ) : (
                        <div className="w-full h-full bg-[#141414] flex items-center justify-center">
                            <span className="text-gray-400">No Media Available</span>
                        </div>
                    )}
                </div>
                <div className="p-2">
                    <div className="flex items-center p-2 bg-[#070707] rounded-lg">
                        <p className="text-base font-medium text-white bg-[#141414] rounded-lg px-2 py-1">{name}</p>
                    </div>
                    
                    <div className="bg-[#070707] p-2 mt-2 rounded-lg flex justify-between items-center">
                        <div className="min-h-[3.5rem]">
                            <p className="text-lg font-bold text-white ml-1">
                                {priceLabel ? `${priceLabel} ${currency ?? ""}`.trim() : ""}
                            </p>
                            {is_limited && remaining_supply !== null && remaining_supply !== 0 && (
                                <p className="bg-[#141414] text-metaxseed-text-gray text-xs font-normal px-2 py-1 rounded-lg inline-block">
                                    <span>
                                    {remaining_supply} remaining
                                    </span>
                                </p>
                            )}
                        </div>
                        <button className="bg-metaxseed-blue text-white font-semibold px-4 py-2 rounded-lg">BUY</button>
                    </div>
                </div>
            </Card>
        </Link>
    ))
  );
};

export default ProductCard;